// import React, { useEffect, useState } from "react";
// import axios from "axios";


// const SuperuserDashboard = () => {
//   const [users, setUsers] = useState([]);
//   const [newUser, setNewUser] = useState({ email: "", role: "employee" });
//   const [message, setMessage] = useState("");
//   const apiUrl = process.env.REACT_APP_API_URL;
//   const token = localStorage.getItem("jwt");

//   // Fetch all users
//   const fetchUsers = async () => {
//     try {
//       const res = await axios.get(`${apiUrl}/users`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       setUsers(res.data);
//     } catch (err) {
//       setMessage(err.response?.data?.error || "Error fetching users");
//     }
//   };

//   useEffect(() => {
//     fetchUsers();
//   }, []);

//   // Create new user
//   const handleCreateUser = async () => {
//     if (!newUser.email) return setMessage("Email is required");
//     try {
//       await axios.post(`${apiUrl}/users`, newUser, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       setMessage("User created successfully!");
//       setNewUser({ email: "", role: "employee" });
//       fetchUsers();
//     } catch (err) {
//       setMessage(err.response?.data?.error || "Error creating user");
//     }
//   };

//   // Delete user
//   const handleDeleteUser = async (id) => {
//     try {
//       await axios.delete(`${apiUrl}/users/${id}`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       setMessage("User deleted successfully!");
//       fetchUsers();
//     } catch (err) {
//       setMessage(err.response?.data?.error || "Error deleting user");
//     }
//   };

//   return (
//     <div style={{ maxWidth: 800, margin: "20px auto" }}>
//     <h2>Superuser Dashboard</h2>
//       {message && <p style={{ color: "red" }}>{message}</p>}

//       {/* Create User Form */}
//       <div style={{ marginBottom: "20px", border: "1px solid #ccc", padding: "10px" }}>
//         <h3>Create New User</h3>
//         <input
//           type="email"
//           placeholder="Email"
//           value={newUser.email}
//           onChange={(e) => setNewUser({ ...newUser, email: e.target.value })}
//           style={{ width: "100%", padding: "8px", marginBottom: "10px" }}
//         />
//         <select
//           value={newUser.role}
//           onChange={(e) => setNewUser({ ...newUser, role: e.target.value })}
//           style={{ width: "100%", padding: "8px", marginBottom: "10px" }}
//         >
//           <option value="employee">Employee</option>
//           <option value="admin">Admin</option>
//         </select>
//         <button onClick={handleCreateUser} style={{ width: "100%", padding: "8px" }}>
//           Create User
//         </button>
//       </div>

//       {/* Users Table */}
//       <div>
//         <h3>All Users</h3>
//         <table style={{ width: "100%", borderCollapse: "collapse" }}>
//           <thead>
//             <tr>
//               <th style={{ border: "1px solid #ccc", padding: "8px" }}>ID</th>
//               <th style={{ border: "1px solid #ccc", padding: "8px" }}>Email</th>
//               <th style={{ border: "1px solid #ccc", padding: "8px" }}>Role</th>
//               <th style={{ border: "1px solid #ccc", padding: "8px" }}>Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {users.map((user) => (
//               <tr key={user.id}>
//                 <td style={{ border: "1px solid #ccc", padding: "8px" }}>{user.id}</td>
//                 <td style={{ border: "1px solid #ccc", padding: "8px" }}>{user.email}</td>
//                 <td style={{ border: "1px solid #ccc", padding: "8px" }}>{user.role}</td>
//                 <td style={{ border: "1px solid #ccc", padding: "8px" }}>
//                   <button onClick={() => handleDeleteUser(user.id)}>Delete</button>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// };

// export default SuperuserDashboard;



import React, { useEffect, useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import Watermark from "../components/Watermark";

const roles = [
  { id: 1, name: "employee" },
  { id: 2, name: "admin" },
];

const initialForm = {
  email: "",
  first_name: "",
  last_name: "",
  dob: "",
  employee_id: "",
  role_id: 1,
};

const emailRegex = /^[a-zA-Z0-9._%+-]+@greenated\.com$/;
const empIdRegex = /^[a-zA-Z0-9]+$/;
const nameRegex = /^[A-Za-z\s]+$/;

const SuperuserDashboard = () => {
  const [users, setUsers] = useState([]);
  const [form, setForm] = useState(initialForm);
  const [editingId, setEditingId] = useState(null);
  const [loading, setLoading] = useState(false);

  const apiUrl = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("jwt");

  // Fetch all users
  const fetchUsers = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${apiUrl}/users`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setUsers(res.data);
    } catch (err) {
      toast.error("Failed to fetch users");
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchUsers();
    // eslint-disable-next-line
  }, []);

  // Validate form
  const validate = () => {
    if (
      !form.email ||
      !form.first_name ||
      !form.last_name ||
      !form.dob ||
      !form.employee_id ||
      !form.role_id
    ) {
      toast.error("All fields are required");
      return false;
    }
    if (!nameRegex.test(form.first_name) || !nameRegex.test(form.last_name)) {
      toast.error("Names must contain only alphabets and spaces");
      return false;
    }
    if (!emailRegex.test(form.email)) {
      toast.error("Email must be @greenated.com");
      return false;
    }
    if (!empIdRegex.test(form.employee_id)) {
      toast.error("Employee ID must be alphanumeric");
      return false;
    }
    if (new Date(form.dob) > new Date()) {
      toast.error("Date of Birth cannot be in the future");
      return false;
    }
    return true;
  };

  // Create or update user
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    try {
      if (editingId) {
        await axios.put(
          `${apiUrl}/users/${editingId}`,
          form,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        toast.success("User updated!");
      } else {
        await axios.post(
          `${apiUrl}/users`,
          form,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        toast.success("User created!");
      }
      setForm(initialForm);
      setEditingId(null);
      fetchUsers();
    } catch (err) {
      toast.error(err.response?.data?.error || "Error saving user");
    }
  };

  // Edit user
  const handleEdit = (user) => {
    setForm({
      email: user.email,
      first_name: user.first_name,
      last_name: user.last_name,
      dob: user.dob ? user.dob.split("T")[0] : "",
      employee_id: user.employee_id,
      role_id: user.role_id,
    });
    setEditingId(user.id);
  };

  // Delete user
  const handleDelete = async (id) => {
    const userToDelete = users.find(u => u.id === id);
    const isSuper = userToDelete && (userToDelete.role === "superuser" || userToDelete.role_id === 3);

    if (isSuper) {
      toast.error("Cannot delete a superuser");
      return;
    }
    
    if (!window.confirm("Are you sure you want to delete this user?")) return;
    try {
      await axios.delete(`${apiUrl}/users/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success("User deleted!");
      fetchUsers();
    } catch (err) {
      console.error("Delete user error:", err);
      const serverMsg = err.response?.data?.error || err.response?.data?.message;
      const msg = serverMsg || err.message || "Error deleting user";
      toast.error(msg);
    }
  };

  return (
    // stack on small screens, side-by-side on lg and up
    <div className="flex flex-col lg:flex-row min-h-screen text-black p-6 lg:p-8 gap-6 lg:gap-8">
    <Watermark /> {/* Watermark Component */}
      {/* Left: User Form */}
      <div className="w-full lg:max-w-[360px] bg-white rounded-2xl p-6 lg:p-8 shadow-lg flex flex-col">
        <h2 className="text-2xl font-bold mb-6">{editingId ? "Edit User" : "Create New User"}</h2>
        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <input
            name="email"
            value={form.email}
            onChange={e => setForm({ ...form, email: e.target.value })}
            placeholder="Email (must be @greenated.com)"
            className="rounded-lg bg-white text-black px-4 py-3"
            required
            disabled={!!editingId}
          />
          <input
            name="first_name"
            value={form.first_name}
            onChange={e => setForm({ ...form, first_name: e.target.value })}
            placeholder="First Name"
            className="rounded-lg bg-white text-black px-4 py-3"
            required
          />
          <input
            name="last_name"
            value={form.last_name}
            onChange={e => setForm({ ...form, last_name: e.target.value })}
            placeholder="Last Name"
            className="rounded-lg bg-white text-black px-4 py-3"
            required
          />
          <input
            type="date"
            name="dob"
            value={form.dob}
            onChange={e => setForm({ ...form, dob: e.target.value })}
            placeholder="Date of Birth"
            className="rounded-lg bg-white text-black px-4 py-3"
            required
            max={new Date().toISOString().split("T")[0]}
          />
          <input
            name="employee_id"
            value={form.employee_id}
            onChange={e => setForm({ ...form, employee_id: e.target.value })}
            placeholder="Employee ID (alphanumeric)"
            className="rounded-lg bg-white text-black px-4 py-3"
            required
          />
          <select
            name="role_id"
            value={form.role_id}
            onChange={e => setForm({ ...form, role_id: Number(e.target.value) })}
            className="rounded-lg bg-white text-black px-4 py-3"
            required
          >
            {roles.map(r => (
              <option key={r.id} value={r.id}>{r.name.charAt(0).toUpperCase() + r.name.slice(1)}</option>
            ))}
          </select>
          <button
            type="submit"
            className="mt-4 py-3 rounded-lg bg-[#7AA33E] text-white font-semibold hover:bg-neon-lime transition"
          >
            {editingId ? "Update User" : "Create User"}
          </button>
          {editingId && (
            <button
              type="button"
              className="py-3 px-4 rounded-lg bg-red-500 text-white font-semibold hover:bg-red-600 transition"
              onClick={() => { setForm(initialForm); setEditingId(null); }}
            >
              Cancel
            </button>
          )}
        </form>
      </div>

      {/* Right: User List (responsive) */}
      <div className="flex-1 bg-white rounded-2xl p-4 lg:p-8 shadow-lg flex flex-col overflow-hidden">
        <h2 className="text-2xl font-bold mb-4">Users</h2>

        {/* horizontal scroll on small screens */}
        <div className="overflow-x-auto w-full">
          <table className="w-full min-w-[800px] table-auto">
            <thead>
              <tr className="text-sm">
                <th className="py-2 px-3 text-left w-[220px]">Email</th>         {/* reduced */}
                <th className="py-2 px-3 text-left w-[120px]">First Name</th>    {/* reduced */}
                <th className="py-2 px-3 text-left w-[120px]">Last Name</th>     {/* reduced */}
                <th className="py-2 px-3 text-left w-[100px]">DOB</th>           {/* reduced */}
                <th className="py-2 px-3 text-left w-[120px]">Employee ID</th>   {/* reduced */}
                <th className="py-2 px-3 text-left w-[90px]">Role</th>          {/* reduced */}
                <th className="py-2 px-3 text-right w-[140px]">Actions</th>     {/* fixed width, right aligned */}
              </tr>
            </thead>

            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={7} className="text-center py-8">Loading...</td>
                </tr>
              ) : users.length === 0 ? (
                <tr>
                  <td colSpan={7} className="text-center py-8 text-muted">No users found.</td>
                </tr>
              ) : (
                users.map(user => (
                  <tr key={user.id} className="border-b hover:bg-gray-50 transition">
                    <td className="py-2 px-3 max-w-[220px] truncate">{user.email}</td>
                    <td className="py-2 px-3 max-w-[120px] truncate">{user.first_name}</td>
                    <td className="py-2 px-3 max-w-[120px] truncate">{user.last_name}</td>
                    <td className="py-2 px-3 max-w-[100px]">{user.dob ? new Date(user.dob).toLocaleDateString() : "-"}</td>
                    <td className="py-2 px-3 max-w-[120px] truncate">{user.employee_id}</td>
                    <td className="py-2 px-3 max-w-[90px]">{roles.find(r => r.id === user.role_id)?.name || "-"}</td>
                    <td className="py-2 px-3 flex gap-2 justify-end whitespace-nowrap w-[140px]">
                      <button
                        className="px-3 py-1 rounded bg-neon-lime text-white font-semibold hover:bg-neon-purple transition"
                        onClick={() => handleEdit(user)}
                      >
                        Edit
                      </button>

                      {!(user.role === "superuser" || user.role_id === 3) ? (
                        <button
                          className="px-3 py-1 rounded bg-red-500/80 text-white text-xs font-semibold"
                          onClick={() => handleDelete(user.id)}
                        >
                          Delete
                        </button>
                      ) : (
                        <button
                          className="px-3 py-1 rounded bg-gray-600/70 text-white text-xs font-semibold cursor-not-allowed"
                          title="Cannot delete superuser"
                          disabled
                        >
                          Delete
                        </button>
                      )}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default SuperuserDashboard;
